exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-header{font-size:1.4em;padding:10px 15px;border-bottom:1px solid #eee}.image-page-full .page-header{background:#252829;border-bottom:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/sass-loader!./components/header/header.scss
 ** module id = 300
 ** module chunks = 0
 **/